import styled, { css } from "styled-components";
import {
    IPointsGain,
    IStampContainer,
    IDiamondIcon,
    IPointsAmount,
} from "./types";
import { mergeStampAnim, pointsAnim, addPointsToBar } from "./keyframes";

const Styles = {
    StampsWrapper: styled.div`
        margin-top: -8%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 80%;
        height: 40%;
        z-index: 1000;
    `,
    StampContainer: styled.div<IStampContainer>`
        animation-fill-mode: forwards;
       
        position: absolute;
        display: flex;
        width: 25%;
        max-width: 25%;
        min-width: 25%;
        height: 100%;
        min-height: 100%;
        margin: 0% 2% 0% 2%;

        left: ${({ left }) => left + "%"};
        top: 10%;
        ${({ animActive }) =>
            animActive &&
            css`
                animation: ${mergeStampAnim} 0.5s ease-in-out;
            `}
        ${({ addCoinAnimActive, leftDest, topDest }) =>
            addCoinAnimActive &&
            css`
                animation: ${addPointsToBar({
                        leftDest,
                        topDest,
                    })}
                    1s ease-in-out;
                animation-fill-mode: forwards;
                animation-delay: 0.5s;
            `}
    `,
    Stamp: styled.img`
        position: relative;
        width: 100%;
        height: 100%;
        transition: 1s;
        object-fit: contain;
    `,

    PointsGain: styled.img<IPointsGain>`
        visibility: ${({ animActive }) =>
            animActive === true ? "visible" : "hidden"};
        position: absolute;
        top: 0%;
        z-index: 1000;
        height: 100%;
        left: -10%;
    `,
    PointsAmount: styled.div<IPointsAmount>`
        animation: ${({ isAnimationActive }) =>
            isAnimationActive === true
                ? css`
                      ${pointsAnim} 2.3s ease-in-out
                  `
                : "unset"};
        animation-fill-mode: forwards;
        position: absolute;
        color: white;
        font-size: 5.5vw;
        top: 40%;
        z-index: 3000;
        text-shadow: 0.25vw 0.25vw 0px rgba(42, 42, 42, 1);
        height: auto;
        font-weight: 700;
        justify-content: center;
        align-items: center;
        left: 0%;
    `,
    DiamondIcon: styled.img<IDiamondIcon>`
        animation: ${({ isAnimationActive }) =>
            isAnimationActive === true
                ? css`
                      ${pointsAnim} 2.3s ease-in-out
                  `
                : "unset"};
        position: relative;
        z-index: 3000;
        width: 30%;
        height: 30%;
        margin-top: 40%;
        left: -48%;
    `,
};

export default Styles;